import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function duplicateDocumentsReducer(state = initialstate.duplicateDocuments, action) {
	switch (action.type) {
		case types.ADD_DUPLICATE_DOCUMENT: {
			let unsortedDocuments = [...state, action.meta.document];
			return unsortedDocuments.sort((a, b) => (a.documentName.toLowerCase() > b.documentName.toLowerCase() ? 1 : -1));
		}
		case types.CLEAR_DUPLICATE_DOCUMENTS:
			return [];
		case types.SELECT_DOCUMENT_OVERWRITE: {
			return state.map((doc) => {
				let newDoc = Object.assign({}, doc);
				if (newDoc.documentName === action.meta.documentName) {
					newDoc.isOverWrite = action.meta.isOverWrite;
				}
				return newDoc;
			});
		}
		default:
			return state;
	}
}
